module.exports = __webpack_public_path__ + "img/1009a_2.1f4fcb95.jpg";